import {
  SET_MAP_VIEW_MODE
} from '../types/mapTypes';





const initialState = {
  mapViewMode: 'street' // 'street' or 'satellite'
};

const mapReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MAP_VIEW_MODE:
      return {
        ...state,
        mapViewMode: action.payload
      };

    default:
      return state;
  }
};





export default mapReducer; 